(function ($) {
    var $fn = $(".comp_featuring");

    if($fn.length){
        var $slider = $fn.find("[data-slider]"),
            $slider_caption = $fn.find("[data-slider-caption]");
            // $autoplay = ($slider.attr("data-autoplay")),
            // $autoplay_speed = ($autoplay)?$slider.data("autoplay"):0;

        if ($slider.children().length > 3) {
            $slider.slick({
                accessibility: false,
                infinite: true,
                speed: 500,
                fade: false,
                focusOnSelect: false,
                slidesToShow: 3,
                cssEase: 'linear',
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: true,
                prevArrow: "<a class='slick-prev slick-arrow icon--chevron-left'></a>",
                nextArrow: "<a class='slick-next slick-arrow icon--chevron-right'></a>",
                pauseOnHover: false,
                dots: false,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    }
})(jQuery);